import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ApiRequest from "../../utils/ApiRequest";
import { ButtonOutline } from "../styledConstants";
import IconDownload from "../../assets/images/IconDownload";

const PdfDownApi = ({
  tableHeader,
  getTableBody,
  url,
  params,
  heading = "",
  fileName = "Report",
  width = 800,
  method = "post",
  digit = 0,
  type = ""
}) => {
  const [data, setData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [triggerDownload, setTriggerDownload] = useState(false);

  // Generate PDF when triggerDownload is set
  useEffect(() => {
    if (triggerDownload && data.length > 0) {
      const tableBody = getTableBody(data);
      generatePDF(tableBody);
      setTriggerDownload(false);
    }
  }, [triggerDownload, data]);

  const downloadReport = () => {
    if (isDisabled) return;
    setIsDisabled(true);
    fetchData();

    setTimeout(() => {
      setIsDisabled(false);
    }, 15000);
  };

  const fetchData = () => {
    const successHandler = (res) => {
      let contentData =
        method === "get" ? res?.data?.metaInfo?.data || [] : res?.data?.metaInfo?.data || [];

      if (digit === 1) {
        contentData = contentData.map((value) => ({
          ...value,
          transactionId: " txn_ " + value.transactionId,
        }));
      }

      setData(contentData);
      setTriggerDownload(true);
    };

    const errorHandler = () => {
      // Handle errors (toast/logging)
    };

    const api = new ApiRequest("", successHandler, errorHandler, false);
    method === "post" ? api.post(url, params) : api.get(url);
  };

  const generatePDF = (tableBody) => {
    const doc = new jsPDF("l", "px", [width, 600]);

    if (heading) {
      doc.text(heading, doc.internal.pageSize.width / 2, 20, { align: "center" });
    }

    doc.autoTable({
      head: tableHeader,
      body: tableBody,
      startY: 30,
      styles: { overflow: "linebreak", cellWidth: "wrap" },
      columnStyles: { text: { cellWidth: "auto" } },
    });

    doc.save(`${fileName || "document"}.pdf`);
  };

  return (
    <ButtonOutline
      className="flex flex-center"
      primary
      rg
      onClick={downloadReport}
      disabled={isDisabled}
      style={{
        cursor: isDisabled ? "not-allowed" : "pointer",
        opacity: isDisabled ? 0.6 : 1,
      }}
    >
      <IconDownload className="mr8" />
      {isDisabled ? "Please wait..." : "PDF"}
    </ButtonOutline>
  );
};

export default PdfDownApi;
